/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { defineProperty, computed } from '@ember/object';
import computedChange from 'cio/utils/computed-change';
import { chanceToBeatControl } from 'cio/helpers/cio-math';
import { isEmpty } from '@ember/utils';
import { MIN_TRIALS } from 'cio/utils/split-tests';
import { SplitMetric } from 'cio/utils/metrics/models/split-metric';
import { VariationBadge } from 'cio/models/action';
import { findDenominator, MeasureType } from 'cio/utils/metrics/measure';
import { Measure, SplitMetricMeasure } from 'cio/utils/metrics/common';

interface CampaignSplitResultsTableRowArgs {
  metric: SplitMetric;
  measure: { key: string; title: string };
  originalMetric: SplitMetric;
  index: number;
  badge: VariationBadge;
  name?: string;
}

function computedChanceToBeat(key: SplitMetricMeasure) {
  let denominator = findDenominator(key as Measure, MeasureType.DeliveryMetrics, 'email_action') as SplitMetricMeasure;

  return computed(
    `args.originalMetric.${key}.rawTotal`,
    `args.metric.${key}.rawTotal`,
    `args.originalMetric.${denominator}.rawTotal`,
    `args.metric.${denominator}.rawTotal`,
    function (this: CampaignSplitResultsTableRow) {
      let chance = chanceToBeatControl(
        this.args.originalMetric[key]?.rawTotal,
        this.args.metric[key]?.rawTotal,
        this.args.originalMetric[denominator]?.rawTotal,
        this.args.metric[denominator]?.rawTotal,
      );

      if (isNaN(chance)) {
        return null;
      }

      return chance;
    },
  );
}

export default class CampaignSplitResultsTableRow extends Component<CampaignSplitResultsTableRowArgs> {
  get name() {
    return this.args.name ?? 'Variation';
  }

  loserBound = 0.05;
  winnerBound = 0.95;

  get notEnoughData() {
    let denominator = findDenominator('converted', MeasureType.DeliveryMetrics, 'email_action') as SplitMetricMeasure;
    return (this.args.metric[denominator]?.rawTotal ?? 0) < MIN_TRIALS;
  }

  change: any = null;
  chanceToBeatOriginal: any = null;

  constructor(owner: unknown, args: CampaignSplitResultsTableRowArgs) {
    super(owner, args);

    let { key } = this.args.measure;

    if (!isEmpty(key)) {
      defineProperty(this, 'change', computedChange(`${key}.rawRate`, 'args.originalMetric', 'args.metric'));
      defineProperty(this, 'chanceToBeatOriginal', computedChanceToBeat(key as SplitMetricMeasure));
    }
  }
}
